// 登记注册

import React from 'react';
import Widget from '../../widget/Widget';
import WidgetAjax from '../../widget/WidgetAjax';
import Cache from '../../frame/Cache';
import Config from '../../config/Config';
import WidgetInterfaceTable from '../../widget/WidgetInterfaceTable';

import '../../css/analysis.css';
import WidgetTable from '../../widget/WidgetTable';

class Transaction extends React.Component 
{   
    constructor()
    {
        super();

        let url = Config.getHermesPanoramaURL();
        let UID = Config.getHermesPanoramaUID();
        
        let basePath = Config.getBasePath();

        let entname = Widget.getSessionStorage("entname");

        this.state = {
            url : url,
            basePath:basePath,
            loading:true,
            baseInfo : {
                ENTNAME : "",
                NAME : "",
                UNISCID : "",
                REGCAP : "",
                ENTTYPE : "",
                REGSTATE : "",
                INDUSTRYPHY : "",
                INDUSTRYCO : "",
                ESTDATE : "",
                APPRDATE : "",
                DOM : "",
                REGORG : "",
                OPSCOPE : ""
            },
            params :{
                'user':UID,
                'ENTNAME' : entname
            },
            column1:[
                {name:'INV', title:'股东名称', type:'string'},
                {name:'INVTYPE', title:'股东类型', type:'string'},
                {name:'SUBCONAM', title:'认缴出资额', type:'string'},
                {name:'SUBCONPROP', title:'认缴出资比例', type:'string'},
                // {name:'SUBCONCUR', title:'认缴出资币种', type:'string'},
                // {name:'SUBCONFORM', title:'认缴出资方式', type:'string'},
                // {name:'SUBCONDATE', title:'认缴出资日期', type:'string'},
                // {name:'COUNTRY', title:'国别', type:'string'}
            ],
            column2:[
                {name:"NAME",title:"姓名", type:"string"},
                {name:"POSITION",title:"职务", type:"string"},
                {name:"LEREPSIGN",title:"是否法定代表人", type:"string"}
            ],
            column3:[
                {name:"ALTDATE", title:"变更时间", type:"string"},
                {name:"ALTITEM", title:"变更事项", type:"string"},
                {name:"ALTBE", title:"变更前内容", type:"string"},
                {name:"ALTAF", title:"变更后内容", type:"string"},
            ],
            activeType: 1,
            column4:[
                {name:"bank", title:"银行名称", type:"string"},
                {name:"count", title:"交易笔数", type:"string"}
            ],
            column5:[
                {name:"bank", title:"银行名称", type:"string"},
                {name:"money", title:"交易金额(万)", type:"string"}
            ],
            assetEvalInfo:{},
            data:[
                {name: '中国建设银行', num: '500-1000'},
                {name: '中国招商银行', num: '800-1000'},
            ],
            data1:[
                {name: '中国建设银行', num: '500-1000'},
                {name: '中国招商银行', num: '800-1000'},
            ],
        };

        this.onLoadBaseInfo = this.onLoadBaseInfo.bind(this);

        this.onLoadToken = this.onLoadToken.bind(this);

        this.getAssetEvalInfo = this.getAssetEvalInfo.bind(this);
        this.onGetAssetEvalInfo = this.onGetAssetEvalInfo.bind(this);

        this.getEntityBankRelationship = this.getEntityBankRelationship.bind(this);
        this.onGetEntityBankRelationship = this.onGetEntityBankRelationship.bind(this);
        
        Config.getHermesAccess( this.onLoadToken );
    };

    componentDidUpdate( )
    {
        let entname = Widget.getSessionStorage("entname");

        let { params } = this.state;

        if( params.ENTNAME!==entname )
        {
            this.state["params"]["ENTNAME"] = entname;
            Config.getHermesAccess( this.onLoadToken );
        }  
    }
    
    change(item)
    {
        
        for( let i=0; i<item.target.parentNode.childNodes.length; i++ )
        {
            item.target.parentNode.childNodes[i].className = "title-label";
        }

        item.target.className = 'title-label title-label-active';

        let id = item.target.id.split("_")[0];
        let e = document.getElementById(id);
        e.scrollIntoView({behavior:'smooth'}); 

    }

    /**
     * 获取 token 回调函数
     * @param {*} result 
     * @returns 
     */
    onLoadToken( result )
    {
        const { url } = this.state;
        
        let { params } = this.state;
         
        if( result.status===0 )
        {
            params["access"] =  result.result.token;
 
            WidgetAjax.ajax({url : url, params : {...params, ...{"service":"getBaseInfo"}}, callback : this.onLoadBaseInfo, backParam:{params:{}} });

            this.setState({ loading: true, params:params});

            this.getAssetEvalInfo(params);

            this.getEntityBankRelationship(params);
        }
        else
        {
            return ;
        }  
    }

    onLoadBaseInfo( result, params )
    { 
        if( result.status===0 && result.result!==undefined )
        {
            this.setState({baseInfo:result.result,loading:false});
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
        
    }

    getAssetEvalInfo( params )
    {
        const { basePath } = this.state;
        
        params = {...params, ...{"service":"getAssetEvalInfo"}};

        WidgetAjax.ajax({url :  basePath + "/entity/portrait", params : params, callback : this.onGetAssetEvalInfo, backParam:{params:params} });
    }

    onGetAssetEvalInfo(result, params )
    {
        if( result.status===0 && result.result!==undefined )
        {
            this.setState({assetEvalInfo:result.result,loading:false});
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }


    getEntityBankRelationship( params )
    {
        const { basePath } = this.state;
        
        params = {...params};

        WidgetAjax.ajax({url :  basePath + "/entity/bank_relationship", params : params, callback : this.onGetEntityBankRelationship, backParam:{params:params} });
    }

    onGetEntityBankRelationship(result, params )
    {
        if( result.status===0 && result.result!==undefined )
        {
            const data = result.result;

            let data1 = [], data2 = [], data3 = [], data4=[];

            if( data.EXPENDITURE!==undefined )
            {
                data3 = data.EXPENDITURE.countData ? data.EXPENDITURE.countData : [];
                data4 = data.EXPENDITURE.moneyData ? data.EXPENDITURE.moneyData : [];
            }

            if( data.DEPOSIT!==undefined )
            {
                data1 = data.DEPOSIT.countData ? data.DEPOSIT.countData : [];
                data2 = data.DEPOSIT.moneyData ? data.DEPOSIT.moneyData : [];
            }

            this.setState({data1:data1,data2:data2, data3:data3, data4:data4});
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

    Router

    render()
    {
        const {baseInfo, url, params, column1, column2, column3,loading, assetEvalInfo, activeType, column4, column5, data1, data2, data3, data4} = this.state;

        return(
            <div className="page">
                {/* <div className="page-weidu entity-title">
                    <div id="baseInfo_flag" className="title-label title-label-active" onClick={this.change.bind(this)}>基本信息</div>
                    <div id="investorInfo_flag" className="title-label " onClick={this.change.bind(this)}>股东及出资信息</div>
                    <div id="managerInfo_flag" className="title-label " onClick={this.change.bind(this)}>主要管理人员</div>
                    <div id="alterInfo_flag" className="title-label " onClick={this.change.bind(this)}>工商变更</div>
                </div> */}
                <div className="page-content page-overflow entity-content white padding-20" style={{display:"table"}}>
                    <div className="content-top cooperation_bank" style={{padding: '0 20px'}}>
                        <div className="content-title">
                            <div className="img">
                                <img src={require("../../img/riskCompass/bt_left.svg")} alt="es-lint want to get"></img>
                            </div>
                            <div className="font">
                                <span>合作银行指数</span>
                            </div>
                        </div> 
                        <p className='check_tab'>
                            {
                                [{name: '收入', type: 1},{name: '支出', type: 2}].map(item=>{ return <span onClick={()=>{this.setState({activeType: item.type})}} className={activeType === item.type ? 'active_type' : ''} key={item.type}>{item.name}</span>})
                            }
                        </p> 
                        <div className='deal' style={ activeType===1 ? {display:"block"} : {display:"none"} }>
                            <div>
                                <p>交易笔数</p>
                                <WidgetTable data={data1} WidgetTableHeight={true} columns={column4} options={{records:5}} />
                            </div>
                            <div>
                                <p>交易金额</p>
                                <WidgetTable data={data2} WidgetTableHeight={true} columns={column5} options={{records:5}} />
                            </div>
                        </div>
                        <div className='deal' style={ activeType===2 ? {display:"block"} : {display:"none"} }>
                            <div>
                                <p>交易笔数</p>
                                <WidgetTable data={data3} WidgetTableHeight={true} columns={column4} options={{records:5}} />
                            </div>
                            <div>
                                <p>交易金额</p>
                                <WidgetTable data={data4} WidgetTableHeight={true} columns={column5} options={{records:5}} />
                            </div>
                        </div>
                    </div>
                    <div className="content-top taking" style={{padding: '0 20px',zIndex:'10',position:'relative'}}>
                        <div className="content-title">
                            <div className="img">
                                <img src={require("../../img/riskCompass/bt_left.svg")} alt="es-lint want to get"></img>
                            </div>
                            <div className="font">
                                <span>营业收入级别</span>
                            </div>
                            <span className='desc_icon'>?</span>
                            <div className='desc_wrap'>
                                <p><span>&gt;=150000</span><span>一级一等</span></p>
                                <p><span>[80000,150000)</span><span>一级二等</span></p>
                                <p><span>[50000,80000)</span><span>一级三等</span></p>
                                <p><span>[30000,50000)</span><span>二级一等</span></p>
                                <p><span>[15000,30000)</span><span>二级二等</span></p>
                                <p><span>[10000,15000)</span><span>二级三等</span></p>
                                <p><span>[8000,10000)</span><span>三级一等</span></p>
                                <p><span>[6000,8000)</span><span>三级二等</span></p>
                                <p><span>[4000,6000)</span><span>三级三等</span></p>
                                <p><span>[2000,4000)</span><span>四级一等</span></p>
                                <p><span>[1000,2000)</span><span>四级二等</span></p>
                                <p><span>[500,1000)</span><span>四级三等</span></p>
                                <p><span>[300,500)</span><span>五级一等</span></p>
                                <p><span>[200,300)</span><span>五级二等</span></p>
                                <p><span>[100,200)</span><span>五级三等</span></p>
                                <p><span>[50,100)</span><span>六级一等</span></p>
                                <p><span>[30,50)</span><span>六级二等</span></p>
                                <p><span>[12,30)</span><span>六级三等</span></p>
                                <p><span>[6,12)</span><span>七级一等</span></p>
                                <p><span>[1,6)</span><span>七级二等</span></p>
                                <p><span>[0,1)</span><span>七级三等</span></p>
                                <p><span>[-1,0)</span><span>八级一等</span></p>
                                <p><span>[-6,-1)</span><span>八级二等</span></p>
                                <p><span>[-12,-6)</span><span>八级三等</span></p>
                                <p><span>[-30,-12)</span><span>九级一等</span></p>
                                <p><span>[-50,-30)</span><span>九级二等</span></p>
                                <p><span>[-100,-50)</span><span>九级三等</span></p>
                                <p><span>[-200,-100)</span><span>十级一等</span></p>
                                <p><span>[-300,-200)</span><span>十级二等</span></p>
                                <p><span>[-500,-300)</span><span>十级三等</span></p>
                                <p><span>[-1000,-500)</span><span>十一级一等</span></p>
                                <p><span>[-2000,-1000)</span><span>十一级二等</span></p>
                                <p><span>[-4000,-2000)</span><span>十一级三等</span></p>
                                <p><span>[-6000,-4000)</span><span>十二级一等</span></p>
                                <p><span>[-8000,-6000)</span><span>十二级二等</span></p>
                                <p><span>[-10000,-8000)</span><span>十二级三等</span></p>
                                <p><span>[-15000,-10000)</span><span>十三级一等</span></p>
                                <p><span>[-30000,-15000)</span><span>十三级二等</span></p>
                                <p><span>[-50000,-30000)</span><span>十三级三等</span></p>
                                <p><span>[-80000,-50000)</span><span>十四级一等</span></p>
                                <p><span>[-15000,-80000)</span><span>十四级二等</span></p>
                                <p><span>&lt;150000</span><span>十四级三等</span></p>
                            </div>
                        </div> 
                        <div className='baseInfo'>
                            <table>
                                <tbody>
                                    {
                                        assetEvalInfo.ASSGRO!=undefined && assetEvalInfo.ASSGRO_RANK!=undefined ? 
                                        <tr>
                                            <td >资产总额</td>
                                            <td>{assetEvalInfo.ASSGRO_RANK}</td>
                                        </tr>
                                        : 
                                        <></>
                                    }
                                    {
                                        assetEvalInfo.LIAGRO!=undefined && assetEvalInfo.LIAGRO_RANK!=undefined ? 
                                        <tr>
                                            <td >负债总额</td>
                                            <td>{assetEvalInfo.LIAGRO_RANK}</td>
                                        </tr>
                                        : 
                                        <></>
                                    }
                                    {
                                        assetEvalInfo.VENDINC!=undefined && assetEvalInfo.VENDINC_RANK!=undefined ? 
                                        <tr>
                                            <td >营业总收入</td>
                                            <td>{assetEvalInfo.VENDINC_RANK}</td>
                                        </tr>
                                        : 
                                        <></>
                                    }
                                    {
                                        assetEvalInfo.MAIBUSINC!=undefined && assetEvalInfo.MAIBUSINC_RANK!=undefined ? 
                                        <tr>
                                            <td >其中主营业务收入</td>
                                            <td>{assetEvalInfo.MAIBUSINC_RANK}</td>
                                        </tr>
                                        : 
                                        <></>
                                    }
                                    {
                                        assetEvalInfo.RATGRO!=undefined && assetEvalInfo.RATGRO_RANK!=undefined ? 
                                        <tr>
                                            <td >纳税总额</td>
                                            <td>{assetEvalInfo.RATGRO_RANK}</td>
                                        </tr>
                                        : 
                                        <></>
                                    }
                                    {
                                        assetEvalInfo.PROGRO!=undefined && assetEvalInfo.PROGRO_RANK!=undefined ? 
                                        <tr>
                                            <td >利润总额</td>
                                            <td>{assetEvalInfo.PROGRO_RANK}</td>
                                        </tr>
                                        : 
                                        <></>
                                    }
                                    {
                                        assetEvalInfo.NETINC!=undefined && assetEvalInfo.NETINC_RANK!=undefined ? 
                                        <tr>
                                            <td >净利润</td>
                                            <td>{assetEvalInfo.NETINC_RANK}</td>
                                        </tr>
                                        : 
                                        <></>
                                    }
                                    {
                                        assetEvalInfo.TOTEQU!=undefined && assetEvalInfo.TOTEQU_RANK!=undefined ? 
                                        <tr>
                                            <td >所有者权益合计</td>
                                            <td>{assetEvalInfo.TOTEQU_RANK}</td>
                                        </tr>
                                        : 
                                        <></>
                                    }
                                </tbody>
                            </table>
                        </div>    
                    </div>
                </div>
            </div>
        );
    }
}

export default Transaction;
